module.exports = __webpack_public_path__ + "static/media/retirement2.81336565.png";